import React from 'react';

const DailyReport = ({ dailyStats, topProducts }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
      <div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
          <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
            <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>📊 Statystyki dzienne i miesięczne</h5>
          </div>
          <div style={{ padding: '0.75rem' }}>
            {dailyStats ? (
              <div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', marginBottom: '0.5rem' }}>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--success)' }}>{dailyStats?.data?.today_transactions || 0}</h4>
                    <small style={{ fontSize: '0.75rem' }}>Transakcje dzisiaj</small>
                  </div>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--info)' }}>{parseFloat(dailyStats?.data?.today_revenue || 0).toFixed(2)} zł</h4>
                    <small style={{ fontSize: '0.75rem' }}>Przychód dzienny</small>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', marginBottom: '0.5rem' }}>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--info)' }}>{parseFloat(dailyStats?.data?.today_average_transaction || 0).toFixed(2)} zł</h4>
                    <small style={{ fontSize: '0.75rem' }}>Średnia dzienna</small>
                  </div>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--warning)' }}>{parseFloat(dailyStats?.data?.month_average_transaction || 0).toFixed(2)} zł</h4>
                    <small style={{ fontSize: '0.75rem' }}>Średnia miesięczna</small>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--text-muted)' }}>{dailyStats?.data?.month_transactions || 0}</h4>
                    <small style={{ fontSize: '0.75rem' }}>Transakcje w miesiącu</small>
                  </div>
                  <div style={{ border: '1px solid var(--border)', padding: '0.5rem', textAlign: 'center', borderRadius: '0.25rem' }}>
                    <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: 'var(--text)' }}>{parseFloat(dailyStats?.data?.month_revenue || 0).toFixed(2)} zł</h4>
                    <small style={{ fontSize: '0.75rem' }}>Przychód miesięczny</small>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--text-muted)' }}>Brak danych</div>
            )}
          </div>
        </div>
      </div>

      <div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
          <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
            <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>🏆 Top produkty</h5>
          </div>
          <div style={{ padding: '0.75rem' }}>
            {topProducts.length > 0 ? (
              <div>
                {topProducts.slice(0, 5).map((product, index) => {
                  // Payload bestsellerow: nazwa, total_quantity_sold, total_revenue.
                  // (Wczesniej renderowano nieistniejace cena_sprzedazy -> puste "zł".)
                  const nazwa = product.nazwa || product.nazwa_produktu || product.kod_produktu || '—';
                  const sztuk = parseFloat(product.total_quantity_sold) || 0;
                  const przychod = parseFloat(product.total_revenue) || 0;
                  return (
                    <div key={product.id ?? index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem', padding: '0.4rem 0', borderBottom: index < 4 ? '1px solid var(--bg)' : 'none', fontSize: '0.8rem' }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        #{index + 1} {nazwa}
                        <span style={{ color: 'var(--text-muted)', marginLeft: '0.35rem', fontSize: '0.7rem' }}>× {sztuk % 1 === 0 ? sztuk : sztuk.toFixed(2)} szt</span>
                      </span>
                      <span style={{ border: '1px solid var(--info)', color: 'var(--info)', padding: '0.2rem 0.4rem', borderRadius: '0.25rem', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>{przychod.toFixed(2)} zł</span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--text-muted)' }}>Brak danych</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyReport;
